import { render, staticRenderFns } from "./title-details.vue?vue&type=template&id=68881f82&scoped=true"
import script from "./title-details.vue?vue&type=script&lang=js"
export * from "./title-details.vue?vue&type=script&lang=js"
import style0 from "./title-details.vue?vue&type=style&index=0&id=68881f82&prod&theme=dark-theater&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68881f82",
  null
  
)

export default component.exports